import { render } from "./CardProjectTabs.vue?vue&type=template&id=363f6d9d&scoped=true&ts=true"
import script from "./CardProjectTabs.vue?vue&type=script&lang=ts"
export * from "./CardProjectTabs.vue?vue&type=script&lang=ts"

import "./CardProjectTabs.vue?vue&type=style&index=0&id=363f6d9d&scoped=true&lang=scss"

import exportComponent from "/builds/Chirbou/digithia/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-363f6d9d"]])

export default __exports__